'use client';

import React from 'react';
import IndustryHero from './IndustryHero';
import IndustryCard from './IndustryCard';
import ComplianceMatrix from './ComplianceMatrix';
import CaseStudyShowcase from './CaseStudyShowcase';
import ResourceLibrary from './ResourceLibrary';
import ROICalculator from './ROICalculator';
import CTASection from './CTASection';

interface Industry {
  id: string;
  name: string;
  icon: string;
  image: string;
  alt: string;
  description: string;
  challenges: string[];
  solutions: string[];
  compliance: string[];
  caseStudyCount: number;
}

interface ComplianceRequirement {
  standard: string;
  description: string;
  industries: string[];
  icon: string;
}

interface CaseStudy {
  id: string;
  industry: string;
  client: string;
  challenge: string;
  solution: string;
  results: {
    metric: string;
    value: string;
    icon: string;
  }[];
  image: string;
  alt: string;
  testimonial: string;
  author: string;
  role: string;
}

interface Resource {
  id: string;
  title: string;
  type: string;
  industry: string;
  description: string;
  downloadUrl: string;
  icon: string;
}

interface IndustrySolutionsInteractiveProps {
  industries: Industry[];
  complianceRequirements: ComplianceRequirement[];
  caseStudies: CaseStudy[];
  resources: Resource[];
}

const IndustrySolutionsInteractive: React.FC<IndustrySolutionsInteractiveProps> = ({
  industries,
  complianceRequirements,
  caseStudies,
  resources,
}) => {
  return (
    <>
      <IndustryHero
        title="Industry-Specific IT Solutions"
        description="Tailored technology strategies that address the unique challenges, compliance requirements, and operational needs of your industry with proven expertise and measurable results"
      />

      <section className="py-16 bg-background">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {industries.map((industry) => (
                <IndustryCard key={industry.id} industry={industry} />
              ))}
            </div>
          </div>
        </div>
      </section>

      <ComplianceMatrix requirements={complianceRequirements} />

      <CaseStudyShowcase caseStudies={caseStudies} />

      <ROICalculator />

      <ResourceLibrary resources={resources} />

      <CTASection />
    </>
  );
};

export default IndustrySolutionsInteractive;